import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { varAlpha, stylesMode } from 'src/theme/styles';

// ----------------------------------------------------------------------

export const StyledLabel = styled(Box)(({ theme, ownerState: { color, variant } }) => {
  const defaultColor = {
    ...(color === 'default' && {
      /**
       * @variant filled
       */
      ...(variant === 'filled' && {
        color: theme.vars.palette.common.white,
        backgroundColor: theme.vars.palette.text.primary,
        [stylesMode.dark]: { color: theme.vars.palette.grey[800] },
      }),
      /**
       * @variant outlined
       */
      ...(variant === 'outlined' && {
        backgroundColor: 'transparent',
        color: theme.vars.palette.text.primary,
        border: `2px solid ${theme.vars.palette.text.primary}`,
      }),
      /**
       * @variant soft
       */
      ...(variant === 'soft' && {
        color: theme.vars.palette.text.secondary,
        backgroundColor: varAlpha(theme.vars.palette.grey['500Channel'], 0.16),
      }),
      /**
       * @variant inverted
       */
      ...(variant === 'inverted' && {
        color: theme.vars.palette.grey[800],
        backgroundColor: theme.vars.palette.grey[300],
      }),
    }),
  };

  const styleColors = {
    ...(color === 'success' && {
      ...(variant === 'filled' && {
        color: '#319656',
        backgroundColor: '#DBF2E4',
      }),
      ...(variant === 'outlined' && {
        backgroundColor: 'transparent',
        color: '#319656',
        border: `2px solid #319656`,
      }),
      ...(variant === 'soft' && {
        color: '#319656',
        backgroundColor: '#DBF2E4',
      }),
    }),
    ...(color === 'error' && {
      ...(variant === 'filled' && {
        color: '#9F004F',
        backgroundColor: '#F6E6EE',
      }),
      ...(variant === 'outlined' && {
        backgroundColor: 'transparent',
        color: '#9F004F',
        border: `2px solid #9F004F`,
      }),
      ...(variant === 'soft' && {
        color: '#9F004F',
        backgroundColor: '#F6E6EE',
      }),
    }),
    ...(color === 'warning' && {
      ...(variant === 'filled' && {
        color: '#E1881F',
        backgroundColor: '#FFF1E0',
      }),
      ...(variant === 'outlined' && {
        backgroundColor: 'transparent',
        color: '#E1881F',
        border: `2px solid #E1881F`,
      }),
      ...(variant === 'soft' && {
        color: '#E1881F',
        backgroundColor: '#FFF1E0',
      }),
    }),
  };

  return {
    height: 24,
    minWidth: 24,
    lineHeight: 0,
    cursor: 'default',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    display: 'inline-flex',
    justifyContent: 'center',
    padding: theme.spacing(0, 0.75),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: theme.shape.borderRadius * 0.75,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.shorter,
    }),
    ...defaultColor,
    ...styleColors,
  };
});
